import {
  Component,
  Optional,
  Inject,
  Input,
  ViewChild,
} from '@angular/core';

import {
  NgModel,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  NG_ASYNC_VALIDATORS,
} from '@angular/forms';

import {ElementBase, animations} from '../';

@Component({
  selector: 'itpx-select',
  templateUrl: './select.component.html',
  styleUrls: [ './select.component.css' ],
  animations,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: SelectComponent,
    multi: true,
  }],
})
export class SelectComponent extends ElementBase<string> {
  @Input() public placeholder: string;

  @ViewChild(NgModel) model: NgModel;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
  ) {
    super(validators, asyncValidators);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/controls/select/select.component.ts